const RECORD_STATUS = {
  none: 0,
  added: 1,
  edited: 2,
  deleted: 3
};
Object.freeze(RECORD_STATUS);

export { RECORD_STATUS };